import { DocumentNameMap } from '@maxhomeai/maxhome-configs';

export const UNKNOWN_DOCUMENT_NAME = 'Unknown Document';

const documentNameMap: Record<string, string> = {
  ...DocumentNameMap,
  UNKNOWN: UNKNOWN_DOCUMENT_NAME,
};

export { documentNameMap };
export type DocumentType = keyof typeof documentNameMap;
